import React, { useState } from "react";
import CopyToClipboard from "react-copy-to-clipboard";

import "./product-share-modal-style.scss";

import BasicModal from "@src/componentsNew/Modals/BasicModal/BasicModal";
import Typography from "@src/componentsNew/Typography/Typography";
import LinkIcon from "@src/componentsNew/Icons/Icons/LinkIcon";
import WhatsAppIcon from "@src/imagesNew/icons/whats-app.svg";

import { product_product } from "@components/ProductPage/ProductDetailPage/__generated__/product";
import {
  getPriceInfoFromProduct,
  getPriceInfoFromVariant,
  formatPrice
} from "@src/utils";

interface IProps {
  product: product_product;
  open: boolean;
  onClose: () => void;
}

const ProductShareModal = ({ product, open, onClose }: IProps) => {
  const [isCopyUrl, setIsCopyUrl] = useState(false);

  const {
    finalPrice,
    discountPercent,
    isOnSale
  } = getPriceInfoFromProduct(product);

  const copyUrl = `https://maccaron.in${product.urlForGraphql}?utm_source=website&utm_medium=productshare&utm_campaign=prodshare`;

  const shareMsg = `How about this product? ${product?.brand} | ${product?.name} | ${formatPrice(finalPrice)} ${isOnSale ? `(${discountPercent}% off)` : ""} | ${copyUrl}`;

  const whatsappUrl = `https://api.whatsapp.com/send?source=&data=&phone=&text=${shareMsg}`;

  const handleClickCopyUrl = () => {
    setIsCopyUrl(true);
  };

  const handleClickWhatsApp = () => {
    window.open(whatsappUrl, "_blank");
  };

  const handleModalClose = () => {
    onClose();
    setIsCopyUrl(false);
  };

  return (
    <BasicModal
      modalId="mobile-detail-share-modal"
      title="Share with your friends"
      titleColor="#212121"
      content={
        <div className="share-modal-wrapper">
          <CopyToClipboard
            text={copyUrl}
            onCopy={handleClickCopyUrl}>
            <div className="share-modal-content">
              <Typography cName="copy-link" variant="body3" component="span" style={{ color: isCopyUrl ? "#0288D1" : "#666666" }}>
                {isCopyUrl ? 'Link Copied!' : 'Copy Link'}
              </Typography>
              <LinkIcon />
            </div>
          </CopyToClipboard>

          <div className="share-modal-content" onClick={handleClickWhatsApp}>
            <Typography cName="whats-app" variant="body3" component="span" style={{ color: "#666666" }}>
              Whats App
            </Typography>
            <img className="whats-app-icon" src={WhatsAppIcon} width={24} />
          </div>
        </div>
      }
      open={open}
      onClose={handleModalClose}
      showCloseIcon={true}
    />
  )
}

export default ProductShareModal;
